import { Text, Title } from '@components/v2/ui';
import {
	Box,
	NumberFormatter,
	Progress,
} from '@mantine/core';
import { getUnitLabel } from '@utils/units';
import { useTranslation } from 'react-i18next';

type ContributionProgressBarProps = {
	total: number;
	allocated: number;
};

export default function ContributionProgressBar({
	total,
	allocated,
}: ContributionProgressBarProps) {
	const { t } = useTranslation();
	const percentage = (allocated / total) * 100;

	return (
		<Box w={'70%'}>
			<Title c={'#505058'} order={6}>
				{t('global.quantityToCompensate')} :{' '}
				<Text c={'#1D3965'} size="20px" span>
					<NumberFormatter
						thousandSeparator=" "
						value={total}
						decimalScale={3}
						suffix={' ' + getUnitLabel('tco2e')}
					/>
				</Text>
			</Title>

			<Box mt={12} mb={8}>
				<Progress
					value={percentage}
					size="lg"
					radius="xl"
					styles={{
						root: {
							backgroundColor: '#A9B4C7',
						},
						section: {
							backgroundColor: '#0F2C59',
						},
					}}
				/>
			</Box>

			<Text c={'#97AAC1'} variant="subtitle1">
				{t('global.allocated')} :{' '}
				<Text span c={'#617EEF'} fw={600}>
					<NumberFormatter
						thousandSeparator=" "
						value={allocated}
						decimalScale={3}
					/>
				</Text>{' '}
				/{' '}
				<NumberFormatter
					thousandSeparator=" "
					value={total}
					decimalScale={3}
					suffix={' ' + getUnitLabel('tco2e')}
				/>
			</Text>
		</Box>
	);
}
